var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7827 5.70306V5.75306H10.8327H11.3837C11.8979 5.75306 12.3164 6.17151 12.3194 6.68277C12.3194 6.68283 12.3194 6.68288 12.3194 6.68294L12.3194 14.0173C12.3194 14.5316 11.901 14.95 11.3867 14.95H1.98265C1.46843 14.95 1.05 14.5316 1.05 14.0173V6.68265C1.05 6.16843 1.46843 5.75 1.98265 5.75H2.53061H2.58061V5.7V4.15102C2.58061 1.89188 4.41948 0.05 6.68163 0.05C8.94377 0.05 10.7827 1.89185 10.7827 4.15408V5.70306ZM9.58368 5.74694H9.63368V5.69694V4.15102C9.63368 2.52239 8.31027 1.19898 6.68163 1.19898C5.053 1.19898 3.72959 2.52239 3.72959 4.15102V5.69694V5.74694H3.77959H9.58368ZM2.19898 13.751V13.801H2.24898H11.1143H11.1173H11.1673V13.751V6.95204V6.90204H11.1173H2.24898H2.19898V6.95204V13.751Z",
    fill: "#0E142C",
    stroke: "white",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25757 12.1927C7.25757 12.511 7.00139 12.7672 6.68308 12.7672C6.36494 12.7672 6.10859 12.5081 6.10859 12.1927V10.5825C6.10859 10.2642 6.36478 10.008 6.68308 10.008C7.00139 10.008 7.25757 10.2642 7.25757 10.5825V12.1927Z",
    fill: "#0E142C",
    stroke: "white",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockDropdownIcon);
export default __webpack_public_path__ + "static/media/lock-dropdown-icon.194c964f96d69b817ad9bbf7d648e981.svg";
export { ForwardRef as ReactComponent };